import { render, staticRenderFns } from "./MeuBancoHorasPage.vue?vue&type=template&id=57712cde&scoped=true"
import script from "./MeuBancoHorasPage.vue?vue&type=script&lang=js"
export * from "./MeuBancoHorasPage.vue?vue&type=script&lang=js"
import style0 from "./MeuBancoHorasPage.vue?vue&type=style&index=0&id=57712cde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57712cde",
  null
  
)

export default component.exports